export default __webpack_public_path__ + "static/eshop-nav-5e664c44c96052fd453c5fa3450580ae.svg";